const NONE = 'None';
const OPTIONAL = 'Optional';
const REQUIRED = 'Required';

export const TorCreationType = Object.freeze({
    [NONE]: 0,
    [OPTIONAL]: 1,
    [REQUIRED]: 2,
});

const IndexedTorCreationType = Object.freeze({
    0: NONE,
    1: OPTIONAL,
    2: REQUIRED,
});

export const TorCreationTypeNames = Object.freeze({
    None: IndexedTorCreationType[TorCreationType.None],
    Optional: IndexedTorCreationType[TorCreationType.Optional],
    Required: IndexedTorCreationType[TorCreationType.Required],
});